import { useMatch } from "react-router";

import { Goto, SessionTab } from "@/shared/navigation";

/**
 * The active session-detail tab: the tab named by the URL segment after
 * `/sessions/:sessionId`, read on every render so the tab strip cannot
 * disagree with the address bar. A URL that names no tab shows Topics.
 */
export function useActiveSessionTab(): SessionTab {
  // React Router decodes each segment but keeps an encoded "/" escaped, so a
  // session id never spans two segments, whatever characters it holds.
  const segment = useMatch(`${Goto.route.Sessions}/:sessionId/:tab`)?.params
    .tab;
  return (
    Object.values(SessionTab).find((tab) => tab === segment) ??
    SessionTab.Topics
  );
}
